module.exports = __webpack_public_path__ + "static/media/discover.b37b2831.png";